(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("subscriptionCheckoutStep3Confirm", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/checkout/subscriptionCheckoutStep3ConfirmView.html",
            controller: ["subscriptionCheckoutService", "messageService", "subscriptionResource", "$scope", "$state", "$translate", SubscriptionCheckoutStep3ConfirmCtrl],
            controllerAs: "vm"
        };
        function SubscriptionCheckoutStep3ConfirmCtrl(subscriptionCheckoutService, messageService, subscriptionResource, $scope, $state, $translate) {
            var vm = this;
            vm.lockButton = false;
            if (!subscriptionCheckoutService.wizard.isStep2Valid) {
                $state.go("main.settings.subscription");
            }
            else {
                subscriptionCheckoutService.setStep(3);
                vm.model = subscriptionCheckoutService.model;
                vm.confirmOrder = function () {
                    if (!vm.lockButton) {
                        var completeModel = {
                            token: vm.model.details.token,
                            updateAccountAddress: vm.model.billingAddress.saveToAccount,
                            orderGuid: vm.model.details.orderGuid
                        };
                        if (vm.model.details.subscriptionTypeName === "Monthly") {
                            completeModel.billingAgreementDescription = $translate.instant("settings.subscription.checkout.Monthly.billingAgreementDescription", { userCount: vm.model.details.items[0].quantity });
                        }
                        vm.lockButton = true;
                        subscriptionResource.complete(completeModel, function () {
                            subscriptionCheckoutService.wizard.isStep3Valid = true;
                            $scope.$emit("clearSubscriptionNotify");
                            $state.go("main.settings.subscriptionCheckout.step4", { orderId: vm.model.details.orderGuid }, { location: "replace" });
                        }, function (errorData) {
                            messageService.error(errorData);
                            $state.go("main.settings.subscriptionCheckout.step2", {}, { location: "replace" });
                        });
                    }
                };
            }
        }
    });
}());
